import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { useAuth, useSpinner } from '@/composables/misc';
import { usersService } from '@/services/users.service';
import { downloadTermsAndConditionsPdf } from '@/utils/misc';
import { DialogProgrammatic } from 'buefy';
import { onMounted, ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN
 * Shows the terms and conditions for the user to accept them.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TermsAgreementModal',
  emits: ['close'],
  setup(__props, { emit }) {



const { t } = useI18n();

onMounted(() => {
  loadTerms();
});

const spinner = useSpinner();
const auth = useAuth();

const rememberDecision = ref<boolean>(false);
const termsHtmlContent = ref<string>('');
const isLoading = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);

function loadTerms() {
  isLoading.value = true;
  usersService
    .getTermsAndConditionsHtmlContent()
    .then((html) => (termsHtmlContent.value = html))
    .finally(() => (isLoading.value = false));
}

async function acceptTermAgreement() {
  isSubmitting.value = true;

  try {
    await usersService.acceptTermsAndConditions(rememberDecision.value);
  } catch (e: any) {
    DialogProgrammatic.alert({
      message: `<p>${t('terms.notify_failed')}</p><p><b>${e.message}</b></p>`,
      onConfirm: () => downloadTermsAndConditionsPdf(),
    });
  } finally {
    isSubmitting.value = false;
  }
  emit('close');
}

async function logout() {
  spinner.showSpinner();
  await usersService.store.update(null);
  await auth.logout().finally(() => spinner.removeSpinner());
}

return { __sfc: true,emit, t, spinner, auth, rememberDecision, termsHtmlContent, isLoading, isSubmitting, loadTerms, acceptTermAgreement, logout }
}

})